import { render, staticRenderFns } from "./HousePinUpload.vue?vue&type=template&id=4a968e48&scoped=true&"
import script from "./HousePinUpload.vue?vue&type=script&lang=js&"
export * from "./HousePinUpload.vue?vue&type=script&lang=js&"
import style0 from "./HousePinUpload.vue?vue&type=style&index=0&id=4a968e48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a968e48",
  null
  
)

export default component.exports